import { AviaPassengerType } from '@websky/graphql';

import { CommonTraveller, SeatMapPassenger } from '../model/types';
import { concatPassengerNames, getPassengerNames } from '../../../../utils';

export function getPassengersInitialState(travellers: CommonTraveller[], extraSeatIds: string[]): SeatMapPassenger[] {
	return travellers.map(traveller => {
		const { lastName, firstName } = getPassengerNames(traveller);
		const fullName = lastName || firstName ? concatPassengerNames({ lastName, firstName }) : null;

		return {
			lastName,
			firstName,
			fullName,
			id: +traveller.id,
			type: traveller.type as AviaPassengerType,
			supplierTravellerType: traveller.supplierTravellerType,
			selectedSeats: traveller.services?.seats ?? [],
			preselectedSeats: traveller.preselectedServices.seats,
			activeDoubleSeat: !!traveller.services?.gdsServices?.services.some(service =>
				extraSeatIds.includes(service.serviceId)
			)
		};
	});
}
